import React, { useState } from 'react';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import { setToken } from '../features/auth/authSlice'; // Acción para guardar el token
import { useNavigate } from 'react-router-dom'; // Hook para redireccionar
import './Login.css';
import Logo from '../assets/gorion.png';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post('https://orionadministracion.com/auth/login', { email, password });
      const { token } = response.data;

      console.log('Inicio de sesión exitoso. Token JWT:', token); // Verificar el token

      dispatch(setToken(token)); // Guardar el token en Redux
      navigate('/servicios'); // Redirigir al usuario
    } catch (error) {
      console.error('Error en el inicio de sesión:', error);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <img src={Logo} alt="ORION Logo" className="logo" />
        <h2>Inicia Sesión</h2>
        <form onSubmit={handleLogin}>
          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label>Contraseña</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <button type="submit" className="login-button">
            Iniciar Sesión
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
